import type { SchemaSite } from './schema-site';
import type { EatalyBreadcrumbItem } from '@/components/eataly-breadcrumbs';

/** Uses the same resolved links and labels as the visible trail. */
export function generateBreadcrumbSchema(items: EatalyBreadcrumbItem[], pageUrl: string, site?: SchemaSite) {
    const trail = site ? [{ id: 'home', label: site.name, href: site.homeUrl }, ...items] : items;
    const seen = new Set<string>();
    const entries = trail.flatMap((item, index) => {
        const path = item.href || (index === trail.length - 1 ? pageUrl : undefined);
        if (!item.label.trim() || !path || path === '#') return [];
        const url = new URL(path, pageUrl).href;
        if (seen.has(url)) return [];
        seen.add(url);
        return [{ '@type': 'ListItem' as const, position: seen.size, name: item.label, item: url }];
    });
    // Google requires at least two genuine trail entries.
    return entries.length > 1
        ? { '@type': 'BreadcrumbList' as const, '@id': `${pageUrl}#breadcrumb`, itemListElement: entries }
        : undefined;
}
